import carrierNegativeImage from "../../assets/images/carrierNegative.png";
import lowRiskAneuploidyVideo from "../../assets/images/lowRiskAneuploidyVideo.png";
import highRisk22qVideo from "../../assets/images/highRisk22qVideo.png";
import lowRisk22qVideo from "../../assets/images/lowRisk22qVideo.png";
import fetalAntigenNiptDetected from "../../assets/images/fetalAntigenNiptDetected.png";
import fetalAntigenNiptNotDetected from "../../assets/images/fetalAntigenNiptNotDetected.png";
import aneuploidyMonosomyX from "../../assets/images/aneuploidyMonosomyX.png";
import rhdDetectedVideo from "../../assets/images/rhdDetectedVideo.png";
import rhdNotDetectedVideo from "../../assets/images/rhdNotDetectedVideo.png";
import aneuploidyZygosity from "../../assets/images/aneuploidyZygosity.png";
import carrierFetalRisk from "../../assets/images/carrierFetalRisk.png";
import unityAneuploidyInfoVideo from "../../assets/images/unityAneuploidyInfoVideo.png";
import billingInsuranceVideo from "../../assets/images/billingInsuranceVideo.png";
import fetalRhdVideo from "../../assets/images/fetalRhdVideo.png";
import smn1SnpVideo from "../../assets/images/smn1_snp_plus.png";

export type Video = {
  name: string;
  url: string;
  image: string;
};

export const videoList: Video[] = [
  {
    name: "CarrierNegative",
    url: "https://player.vimeo.com/video/1057943467?playsinline=0",
    image: carrierNegativeImage,
  },
  {
    name: "LowRiskAneuploidy",
    url: "https://player.vimeo.com/video/1035771695?playsinline=0",
    image: lowRiskAneuploidyVideo,
  },
  {
    name: "HighRisk22Q",
    url: "https://player.vimeo.com/video/1035771784?playsinline=0",
    image: highRisk22qVideo,
  },
  {
    name: "LowRisk22Q",
    url: "https://player.vimeo.com/video/1035771746?playsinline=0",
    image: lowRisk22qVideo,
  },
  {
    name: "FetalAntigenNIPTDetected",
    url: "https://player.vimeo.com/video/1035771652?playsinline=0",
    image: fetalAntigenNiptDetected,
  },
  {
    name: "FetalAntigenNIPTNotDetected",
    url: "https://player.vimeo.com/video/1035771669?playsinline=0",
    image: fetalAntigenNiptNotDetected,
  },
  {
    name: "AneuploidyMonosomyX",
    url: "https://player.vimeo.com/video/1035771767?playsinline=0",
    image: aneuploidyMonosomyX,
  },
  {
    name: "FetalRhdDetected",
    url: "https://player.vimeo.com/video/1035771802?playsinline=0",
    image: rhdDetectedVideo,
  },
  {
    name: "FetalRhdNotDetected",
    url: "https://player.vimeo.com/video/1035771730?playsinline=0",
    image: rhdNotDetectedVideo,
  },
  {
    name: "AneuploidyZygosity",
    url: "https://player.vimeo.com/video/1035771715?playsinline=0",
    image: aneuploidyZygosity,
  },
  {
    name: "CarrierFetalRisk",
    url: "https://player.vimeo.com/video/960668319?playsinline=0",
    image: carrierFetalRisk,
  },
  {
    name: "AneuploidyInfo",
    url: "https://player.vimeo.com/video/960668298?playsinline=0",
    image: unityAneuploidyInfoVideo,
  },
  {
    name: "BillingAndInsuranceProcess",
    url: "https://player.vimeo.com/video/1035775307?playsinline=0",
    image: billingInsuranceVideo,
  },
  {
    name: "FetalRhd",
    url: "https://player.vimeo.com/video/960668334?playsinline=0",
    image: fetalRhdVideo,
  },
  {
    name: "SMN1SNP",
    url: "https://player.vimeo.com/video/1111694716?playsinline=0",
    image: smn1SnpVideo,
  },
];
